export default {
  maskBox: state => state.commondata.maskBox,
  padWarnShow: state => state.commondata.padWarnShow,
  name: state => state.commondata.name,
  userType: state => state.commondata.userType,
  icodeName: state => state.commondata.icodeName,
  userAvator: state => state.commondata.userAvator,
};


// WEBPACK FOOTER //
// ./src/store/getters.js